import { useRef } from "react";

// ONE hover dropdown open at a time, site-wide: opening one closes whichever was open.
let current = null;

// Hover-to-open for nav popovers: opens on enter, closes shortly after the pointer leaves trigger + panel.
export function useHoverOpen(setOpen, delay = 160) {
    const t = useRef(null);
    const close = () => { if (current === setOpen) current = null; setOpen(false); };
    const enter = () => {
        clearTimeout(t.current);
        if (current && current !== setOpen) current(false);
        current = setOpen; setOpen(true);
        window.dispatchEvent(new Event("rosterly:navpop-open"));   // inline nav drawers close
    };
    // Stay open only while a calendar opened FROM this dropdown is showing.
    const leave = () => { clearTimeout(t.current); t.current = setTimeout(() => { if (document.querySelector("[data-nested-pop]")) return; close(); }, delay); };
    // Clicking the trigger after hover-open must not toggle it shut.
    const onClick = (e) => { e.preventDefault(); enter(); };
    return { onMouseEnter: enter, onMouseLeave: leave, onClick };
}

// Inline nav drawers call this when they open, so a hover dropdown never stays open beside them.
export function closeHoverPop() { if (current) { current(false); current = null; } }
